export const getURLForPath = (
  serverURL: string,
  path: string,
  query = {}
): string => {
  const url = new URL(path, serverURL);
  url.search = new URLSearchParams(query).toString();
  return url.toString();
};

export const applyRedirectURI = (
  serverURL: string,
  path: string,
  params = {}
) => {
  return getURLForPath(serverURL, path, {
    ...params,
    redirect_uri: `${serverURL}/callback`,
  });
};
